import wrapIn from 'app/enhancers/wrapIn';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import { UI } from 'app/features/success/mangaBlock/components/MangaBlock';

const MangaBlock = wrapIn(BlockWrapper)(UI);

export default MangaBlock;
